// Copies: these five lists are private consts inside their host components, so there is nothing to
// import (ADR-053).

export const GENDER_IDENTITY_OPTIONS = [
  { value: 'FEMALE', label: 'Female' },
  { value: 'MALE', label: 'Male' },
  { value: 'TRANSGENDER_FEMALE_TO_MALE', label: 'Transgender Male' },
  { value: 'TRANSGENDER_MALE_TO_FEMALE', label: 'Transgender Female' },
  { value: 'NON_BINARY', label: 'Non Binary' },
  { value: 'GENDER_FLUID', label: 'Gender Fluid' },
  { value: 'PREFER_NOT_DISCLOSE', label: 'Prefer Not Disclose' },
]

export const MARITAL_STATUS_OPTIONS = [
  { value: 'SINGLE', label: 'Single' },
  { value: 'MARRIED', label: 'Married' },
  { value: 'DOMESTIC_PARTNERSHIP', label: 'Domestic Partnership' },
  { value: 'DIVORCED', label: 'Divorced' },
  { value: 'WIDOWED', label: 'Widowed' },
  { value: 'SEPARATED', label: 'Separated' },
]

export const RACIAL_IDENTITY_OPTIONS = [
  { value: 'AMERICAN_INDIAN_OR_ALASKA_NATIVE', label: 'American Indian or Alaska Native' },
  { value: 'ASIAN', label: 'Asian' },
  { value: 'BLACK_OR_AFRICAN_AMERICAN', label: 'Black or African American' },
  { value: 'HISPANIC_OR_LATINO', label: 'Hispanic or Latino' },
  { value: 'MIDDLE_EASTERN_OR_NORTH_AFRICAN', label: 'Middle Eastern or North African' },
  { value: 'NATIVE_HAWAIIAN_OR_PACIFIC_ISLANDER', label: 'Native Hawaiian or Pacific Islander' },
  { value: 'WHITE', label: 'White' },
  { value: 'OTHER', label: 'Other' },
  { value: 'PREFER_NOT_DISCLOSE', label: 'Prefer not to disclose' },
]

export const EDUCATION_LEVEL_OPTIONS = [
  { value: 'HIGH_SCHOOL_DIPLOMA_OR_EQUIVALENT', label: 'High school diploma or equivalent' },
  { value: 'SOME_COLLEGE', label: 'Some college' },
  { value: 'BACHELOR_DEGREE', label: "Bachelor's degree" },
  { value: 'GRADUATE_OR_PROFESSIONAL_DEGREE', label: 'Graduate or professional degree' },
  { value: 'OTHER', label: 'Other' },
]

export const OCCUPATION_OPTIONS = [
  { value: 'WORKING', label: 'Working' },
  { value: 'UNEMPLOYED', label: 'Unemployed' },
  { value: 'DISABLED', label: 'Disabled' },
  { value: 'RETIRED', label: 'Retired' },
  { value: 'STUDENT', label: 'Student' },
  { value: 'STAY_AT_HOME_PARENT', label: 'Stay at home parent' },
]
